import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from 'body-scroll-lock'

const Lightbox = () => {
  const images = document.querySelectorAll('.js-lightbox-image')
  if (images.length < 1) return
  ;[...images].forEach((image, index) => {
    image.addEventListener('click', addLightbox.bind(null, image))
  })
}

function addLightbox(element, e) {
  e.preventDefault()
  let currentElement = element
  let prevImg = currentElement.previousElementSibling
  const parentElement = currentElement.parentElement

  if (prevImg) {
    prevImg = prevImg.closest('.js-lightbox-image')
      ? prevImg
      : prevImg.previousElementSibling
  }

  let nextImg = currentElement.nextElementSibling
  if (nextImg) {
    nextImg = nextImg.closest('.js-lightbox-image')
      ? nextImg
      : nextImg.nextElementSibling
  }

  if (parentElement.classList.contains('js-thumbnail-slide')) {
    const nextParent = parentElement.nextElementSibling
    const prevParent = parentElement.previousElementSibling

    if (nextParent) {
      const nextEl = nextParent.querySelector('.js-lightbox-image')
      nextImg = nextEl
    }

    if (prevParent) {
      const prevEl = prevParent.querySelector('.js-lightbox-image')
      prevImg = prevEl
    }
  }

  // get img src
  let url = element.closest('.js-lightbox-image')
  let src = url.getAttribute('href')

  // create lightbox elements
  let lightbox = document.createElement('div')
  let loader = document.createElement('div')
  let image = document.createElement('img')
  let cross = document.createElement('div')
  let next = document.createElement('div')
  let prev = document.createElement('div')

  // set elements
  lightbox.setAttribute('id', 'js-lightbox')
  lightbox.setAttribute('class', 'c-lightbox')
  loader.setAttribute('class', 'c-lightbox__loader')
  image.setAttribute('class', 'c-lightbox__image')
  image.setAttribute('src', src)
  cross.setAttribute('class', 'c-lightbox__cross')
  next.setAttribute('class', 'c-lightbox__next')
  prev.setAttribute('class', 'c-lightbox__prev')

  // add to dom
  document.body.appendChild(lightbox)
  lightbox.appendChild(loader)
  lightbox.appendChild(image)
  lightbox.appendChild(cross)

  if (nextImg) {
    lightbox.appendChild(next)
    next.addEventListener('click', e => {
      e.preventDefault()
      let nextUrl = nextImg.closest('.js-lightbox-image')
      let nextSrc = nextUrl.getAttribute('href')
      currentElement = nextImg
      document.body.removeChild(lightbox)
      addLightbox(nextImg, e)
      image.setAttribute('src', nextSrc)
    })
  }

  if (prevImg) {
    lightbox.appendChild(prev)
    prev.addEventListener('click', e => {
      e.preventDefault()
      let prevUrl = prevImg.closest('.js-lightbox-image')
      let prevSrc = prevUrl.getAttribute('href')
      currentElement = prevImg
      document.body.removeChild(lightbox)
      addLightbox(prevImg, e)
      image.setAttribute('src', prevSrc)
    })
  }

  // on image load
  image.addEventListener('load', () => {
    image.classList.add('c-lightbox__image--loaded')
    loader.classList.add('c-lightbox__loader--loaded')
  })

  disableBodyScroll(currentElement)

  // remove if clicked again
  cross.addEventListener('click', e => {
    if (e.target !== next && e.target !== prev) {
      enableBodyScroll(currentElement)
      document.body.removeChild(lightbox)
      clearAllBodyScrollLocks()
    }
  })
}

export default Lightbox



// WEBPACK FOOTER //
// ./src/js/modules/Lightbox.js